// extracted by mini-css-extract-plugin
export var iconContainer = "WorkPortfolio-module--iconContainer--E35Rd";
export var iconContainerLeft = "WorkPortfolio-module--iconContainerLeft--VD58V";
export var portfolioArrowIcon = "WorkPortfolio-module--portfolioArrowIcon--SU8xG";
export var portfolioArrowIconCover = "WorkPortfolio-module--portfolioArrowIconCover--Uskls";
export var portfolioArrowRightIconCover = "WorkPortfolio-module--portfolioArrowRightIconCover--Ld4Fm";